import { useCallback } from 'react';
import { LOG_ACTIONS, useLogAmplitude } from '@namespace/analytics';
import { useGeneralRoutes, useOtherSettings } from '@namespace/cms';
import { useI18n } from '@namespace/i18n';
import { useThemeComponents } from '@namespace/themes';
import VerificationStatusNotification, {
  MobileMessage
} from '../VerificationStatusNotification';
import { DesktopMessage } from './DesktopMessage/connector';

const NotVerfiedUserToast = ({ onClose }) => {
  const { t } = useI18n();
  const generalRoutes = useGeneralRoutes();
  const {
    verificationToasts: {
      notVerifiedUserToastRoute,
      isCloseAfterLink = false
    } = {}
  } = useOtherSettings();
  const {
    NotVerifiedStatusNotification: PartnerNotVerifiedStatusNotification
  } = useThemeComponents();

  const currentRoute =
    generalRoutes[notVerifiedUserToastRoute ?? 'profileDocuments'];

  const primaryText = t('unverifiedUser.notification.info');
  const linkText = t('unverifiedUser.notification.linkTitle');
  const logAmplitude = useLogAmplitude();

  const handleClose = useCallback(() => {
    logAmplitude({
      actionName: LOG_ACTIONS.VERIFICATION_OPEN,
      attributes: { entry_point: 'popup_notification' }
    });
  }, []);

  const message = (
    <DesktopMessage
      onClose={isCloseAfterLink ? onClose : handleClose}
      actionText={linkText}
      link={currentRoute}
      primaryText={primaryText}
      submitText={t('unverifiedUser.notification.button')}
    />
  );

  const mobileMessage = (
    <MobileMessage
      onClose={isCloseAfterLink ? onClose : handleClose}
      linkText={linkText}
      submitText={t('unverifiedUser.notification.button')}
      link={currentRoute}
      primaryText={primaryText}
    />
  );

  if (PartnerNotVerifiedStatusNotification) {
    return (
      <PartnerNotVerifiedStatusNotification
        link={currentRoute}
        onClose={onClose}
      />
    );
  }

  return (
    <VerificationStatusNotification
      onClose={onClose}
      message={message}
      mobileMessage={mobileMessage}
    />
  );
};

export default NotVerfiedUserToast;
